<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/search.json"></i18n>
<i18n src="@/lang/table.json"></i18n>

<template>
  <el-main>
    <component
      :is="require('../_snippets/header_actions/header_actions').default"
    >
      <template slot="button-group">
        <el-button
          type="primary"
          @click="
            $router.push({ name: 'customers.details', params: { id: 'new' } })
          "
          >{{ $t("actions.new_customer") }}
        </el-button>
      </template>
    </component>
    <el-table :data="customers" style="width: 100%" class="customers-table">
      <el-table-column
        sortable
        property="name"
        :label="$t('table.name')"
      ></el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <component
            :is="require('../images/amocrm_logo').default"
            :size="16"
          />
          <el-badge
            v-for="amo in scope.row.amocrm"
            :key="amo.index"
            is-dot
            class="amo-dot"
            :class="{ red: !amo.confirmed }"
          ></el-badge>
          <!-- <span class="counter">{{ scope.row.countAmo }}</span> -->
        </template>
      </el-table-column>
      <el-table-column>
        <account-ids-column-content slot-scope="{ row }" :customer="row" />
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <i class="el-icon-user-solid"></i>
          <span class="counter">{{ scope.row.countContacts }}</span>
          <i class="el-icon-s-cooperation"></i>
          <span class="counter">{{ scope.row.countServices }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.operations')" align="right">
        <template slot="header" slot-scope="scope">
          <el-input
            :key="scope.index"
            size="mini"
            v-model="filter"
            spa-action="find"
            :placeholder="$t('search.placeholder')"
          />
        </template>
        <template slot-scope="scope">
          <el-dropdown
            split-button
            size="small"
            type="info"
            trigger="click"
            @click="handleEdit(scope.$index, scope.row)"
            @command="
              (...args) => {
                handleDropdownAction(scope.$index, scope.row, ...args);
              }
            "
          >
            {{ $t("actions.view") }}
            <el-dropdown-menu>
              <el-dropdown-item disabled class="dropdown-title">{{
                scope.row.name
              }}</el-dropdown-item>
              <router-link
                :to="{
                  name: 'customers.details',
                  params: { id: scope.row.uuid }
                }"
                tag="el-dropdown-item"
                v-t="'actions.view'"
              ></router-link>
              <el-dropdown-item
                command="SERVICES"
                v-t="'actions.show_services'"
              ></el-dropdown-item>
              <el-dropdown-item
                :disabled="!scope.row.canDelete"
                command="DELETE"
                v-t="'actions.delete'"
              ></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <component
      :is="require('../_snippets/popup/popup_912x616').default"
      :visible.sync="show_services"
    >
      <template slot="content" v-if="show_services && vars_services">
        <el-container>
          <el-main>
            <customers_services_list
              :request_vars="vars_services"
              is_in_customer_datails
            />
          </el-main>
        </el-container>
      </template>
    </component>
  </el-main>
</template>

<script>
import { mapGetters } from "vuex";
import Customers_services_list from "../services/services_list";
import AccountIdsColumnContent from "./elements/account_ids_column_content";

export default {
  name: "customers_list",
  components: {
    Customers_services_list,
    AccountIdsColumnContent
  },
  data() {
    return {
      curPage: 1,
      perPage: 5,
      show_services: false,
      vars_services: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.query(this.refetchQueries[0]);
    },
    handleEdit(index, row) {
      this.$log(index, row);

      this.$router.push({
        name: "customers.details",
        params: {
          id: row.uuid
        }
      });
    },
    handleShowServices(uuid = null) {
      this.vars_services = {
        customer: uuid
      };
      this.show_services = true;
    },
    handleDropdownAction(index, row, action, ...args) {
      this.$log("handleDropdownAction", arguments);
      switch (action) {
        case "DELETE":
          this.$api
            .mutate({
              mutation: require("../../graphql/customers/customer_save.graphql"),
              variables: {
                DELETE: true,
                uuid: row.uuid,
                name: row.name
              }
            })
            .then(() => this.getData());
        // eslint-disable-next-line no-fallthrough
        case "SERVICES":
          this.handleShowServices(row.uuid);
      }
    }
    // handleCurrentPageChage(v){
    //     this.curPage = v;
    //     this.getData();
    // }
  },
  computed: {
    ...mapGetters({
      customers: "shared_customers_list/customers"
    }),
    filter: {
      get() {
        return this.$store.state.shared_customers_list.filter_string;
      },
      set(value) {
        this.$store.commit("shared_customers_list/filter_string", value);
      }
    },
    refetchQueries() {
      return [
        {
          query: require("../../graphql/customers/customers_list.graphql"),
          variables: { count: this.perPage, page: this.curPage }
        }
      ];
    }
  }
};
</script>

<style lang="stylus">
.customers-table
    & .cell
        overflow unset
div.customers-filter {
    display: flex;
    justify-content: space-between;

    & span {
        display: inline-block;
        width: 40px;
    }

    & .el-input.el-input--mini {
        width: fit-content;
    }
}

.counter {
    color: #c6c8ca;
    font-weight: 700;
    margin-right: 0.7rem;

    &:before {
        content: '✕ ';
        font-weight: 100;
    }
}

.dropdown-title {
    font-weight: 800;
    color: #409eff !important;
    text-transform: uppercase;
}

.amo-dot-undefined {
    .el-badge__content {
        background-color: red;
    }
}

.amo-dot {
    .el-badge__content {
        background-color: #88d6f8;
    }

    &.red {
        .el-badge__content {
            background-color: red;
        }
    }
}
</style>

<style lang="stylus" scoped></style>
